import { registerBlockType } from "@wordpress/blocks";
import config, { type BlockAttributes } from "./block.json";
import "../slider/swiper";
import NewsletterEditor from "./newsletterEditor";
import { InnerBlocks } from "@wordpress/block-editor";

registerBlockType<BlockAttributes>(config.name, {
  ...config,

  edit: NewsletterEditor,
  save(props) {
    return (
      <>
        <section className="newsletter position-relative alignfull">
          <img
            className="position-absolute"
            src={props.attributes.imageUrl}
            alt={props.attributes.imageAlt}
          />
          <div className="container h-100">
            <div className="row align-items-center">
              <div className="col-xl-6">
                <InnerBlocks.Content />
              </div>
              <div className="col-xl-6 d-flex flex-column flex-xl-row gap-2 justify-content-center">
                <input type="text" placeholder="E-Mail Adresse eingeben" />
                <div className="ms-1">
                  <a href="" className="button">
                    ABONNIEREN
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  },
});
